import ForecastHead from "rivals/components/pages/Futurecast/ForecastHead";
import ForecasterList from "rivals/components/pages/Futurecast/ForecasterList/container";
import RecentForecasts from "rivals/components/pages/Futurecast/RecentForecasts";
import Benji from "rivals/components/shared/Ads/Benji";
import {
  MID_RIGHT,
  TOP_RIGHT
} from "rivals/components/shared/Ads/Benji/constants";
import LREC from "rivals/components/shared/Ads/LREC";
import AdWrapper from "rivals/components/shared/Ads/WithRedux/container";
import { setData } from "rivals/shared/utils/qa";

const Futurecasts = (): JSX.Element => {
  const philter = "futurecast-page";

  return (
    <div {...setData(philter)}>
      <Benji />
      <ForecastHead />
      <ForecasterList />
      <RecentForecasts
        lrec={
          <AdWrapper
            ad={LREC}
            location={TOP_RIGHT}
            locationCount={1}
            slotNumber={1}
          />
        }
        lrec2={
          <AdWrapper
            ad={LREC}
            location={MID_RIGHT}
            locationCount={1}
            slotNumber={2}
          />
        }
        philter={`${philter}-recent-forecasts`}
      />
    </div>
  );
};

export default Futurecasts;
